import React from "react";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        RushuBD &copy; {new Date().getFullYear()} All Rights Reserved
      </div>
    </div>
  );
};
